import { useContext } from 'react'
import { Skeleton, Tooltip, Typography } from '@mui/material'

import { formatAddress } from '../../../../utils/helpers'
import useSharedStyles from '../../../../utils/shared.styles'
import AccountsContext from '../../context'

const Address = ({ folderId }: { folderId: number }) => {
  const sharedClasses = useSharedStyles
  const { folderTree, isLoading } = useContext(AccountsContext)

  const address1 = folderTree?.[folderId].data?.folder.information.address.address
  const address2 =
    folderTree && folderTree[folderId] && folderTree[folderId].data
      ? formatAddress(
          `${folderTree[folderId].data?.folder.information.address.locality}, ${folderTree[folderId].data?.folder.information.address.region} ${folderTree[folderId].data?.folder.information.address.code} ${folderTree[folderId].data?.folder.information.address.country}`,
          folderTree[folderId].data?.folder.information.address.country ?? ''
        )
      : ''

  if (!isLoading)
    return (
      <Tooltip
        title={
          <>
            {address1 && (
              <>
                {address1}
                <br />
              </>
            )}
            {address2}
          </>
        }
      >
        <div style={sharedClasses.fullWidth}>
          {address1 && (
            <Typography variant="body2" sx={[sharedClasses.overflowText, sharedClasses.secondaryText]} className="fs-exclude">
              {address1}
            </Typography>
          )}
          {address2 && (
            <Typography variant="body2" sx={[sharedClasses.overflowText, sharedClasses.secondaryText]} className="fs-exclude">
              {address2}
            </Typography>
          )}
        </div>
      </Tooltip>
    )
  return (
    <>
      <Skeleton aria-label="Loading address" height="20px" width="120px" />
      <Skeleton height="20px" />
    </>
  )
}

export default Address
